








import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  props: ['msg'],
  filters: {
    formatUnix(timestamp: number): string {
      const date = moment.unix(timestamp).format('HH:mm')
      return date
    },
  },
})
